import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import '../../assets/style/Modal.css';
import ModalHeader from '../../components/ModalHeader';
import CenterSpinner from '../../components/CenterSpinner';
import ViewMarketingActivity from '../../components/ViewMarketingActivity';
import { FormGroup, Input, Label, Row } from 'reactstrap';
import {
  MARKETING_STATUSES,
  saveComment,
} from '../create-activity/activityHelper';
import '../../assets/style/MarketingActivity.css';
import { useAppDispatch } from '../../store/redux-hooks';
import { getNoteDate } from '../../utils/Util';
import { CLICK_ACTIONS } from '../../utils/Constant';
import { useLoader } from '../../loader/LoaderProvider';

interface IViewMarketingActivityModalProps {
  isOpen: boolean;
  activityDetails: any;
  toggleModal: (action: any) => void;
  comment: string;
  setComment: (comment: string) => void;
  setActivityDetails?: (data: any) => void;
}

const ViewMarketingActivityModal: React.FunctionComponent<
  IViewMarketingActivityModalProps
> = ({
  isOpen,
  activityDetails,
  toggleModal,
  comment,
  setComment,
  setActivityDetails = () => {},
}: IViewMarketingActivityModalProps) => {
  const { showLoader, setShowLoader } = useLoader();
  const dispatch = useAppDispatch();
  const [isReviewPending, setIsReviewPending] = useState<boolean>(false);
  const [isCompletedOrRejected, setIsCompletedOrRejected] = useState(false);

  useEffect(() => {
    if (activityDetails) {
      setIsReviewPending(
        activityDetails?.activityStatusId === MARKETING_STATUSES.REVIEW_PENDING
      );
      setIsCompletedOrRejected(
        [MARKETING_STATUSES.COMPLETED, MARKETING_STATUSES.REJECTED].includes(
          activityDetails.activityStatusId
        )
      );
    }
  }, [activityDetails]);

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white rounded border overflow-hidden">
        <ModalHeader
          toggle={() => {
            toggleModal(CLICK_ACTIONS.NO_ACTION);
          }}
          closeOnly
        />
        <ViewMarketingActivity activity={activityDetails} />
        <div className="p-2 pt-0 mt-3">
          <Row className="mt-2 mx-2">
            <Label for="comments" className="header-style">
              Comments
            </Label>
            <div className="bg-comment p-4 mx-2 rounded">
              {!isCompletedOrRejected && (
                <div className="mb-3">
                  <FormGroup>
                    <Input
                      id="comment"
                      name="comment"
                      type="textarea"
                      value={comment}
                      maxLength={250}
                      placeholder="Please enter comments"
                      className="rounded border model-comment-area"
                      onChange={(event) => {
                        if (event.target.value?.length <= 250)
                          setComment(event.target.value);
                      }}
                    />
                  </FormGroup>
                  <Button
                    variant="primary"
                    className="cl-btn-primary"
                    onClick={() => {
                      saveComment(
                        comment,
                        activityDetails,
                        setShowLoader,
                        setComment,
                        setActivityDetails,
                        dispatch
                      );
                    }}
                  >
                    Save
                  </Button>
                </div>
              )}

              <div className="bg-white rounded border px-4 pt-3 pb-3">
                <Label for="comment" className="model-comment-title">
                  Log Details
                </Label>
                <div className="modal-log-div">
                  <ul className="li-item model-log-value">
                    {activityDetails?.notes?.map((noteItem: any) => (
                      <li
                        className="mt-1"
                        key={noteItem?.notesId ?? noteItem?.notesid}
                      >
                        {getNoteDate(noteItem)}
                        {noteItem.notesDescription}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </Row>
        </div>

        <div className="d-flex justify-content-center re-button-parent">
          {!isReviewPending ? (
            <Button
              variant="primary"
              className="cl-btn-primary"
              onClick={() => toggleModal(CLICK_ACTIONS.NO_ACTION)}
            >
              Close
            </Button>
          ) : (
            <Button
              variant="primary"
              className="cl-btn-primary"
              onClick={() => toggleModal(CLICK_ACTIONS.APPROVE)}
            >
              Approve
            </Button>
          )}
        </div>

        <CenterSpinner showLoader={showLoader} />
      </div>
    </ModalComponent>
  );
};

export default ViewMarketingActivityModal;
